<template>
  <div class="stripe">
    <b-container>
      <b-row v-if="auctionStarts != ''">
        <b-col cols="12" md="12" class="stripe-announcement text-center">
          <b-row>
            <b-col cols="12" class="stripe-anouncement-line-1">Próxima subasta</b-col>
            <b-col cols="12" class="stripe-anouncement-line-2">
              <span class="featured">
                <Countdown :date="auctionStarts" />
              </span>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6" class="stripe-search d-none">
          <Search />
        </b-col>
      </b-row>
    </b-container>
    <div class="stripe-color d-none d-md-block">
      <b-container fluid>
        <b-row>
          <b-col class="stripe-left">&nbsp;</b-col>
          <b-col class="stripe-right">&nbsp;</b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Search from "./stripe/Search";
import Countdown from "./utils/Countdown";

export default {
  name: "Stripe",
  components: {
    Search,
    Countdown
  },
  props: {
    auctionStarts: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/partial";

.stripe {
  position: relative;
  color: $white;

  .stripe-announcement {
    background-color: $red;
    text-transform: uppercase;
    font-weight: 800;
    font-size: 2rem;
    line-height: 2.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    > .row {
      align-items: center;

      > * {
        margin-bottom: 2rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    @media (max-width: prev-viewport-max-size("md")) {
      font-size: 2rem;
      line-height: 1.8rem;
    }

    @media (max-width: prev-viewport-max-size("sm")) {
      font-size: 1.3rem;
    }

    @media (max-width: prev-viewport-max-size("xs")) {
      font-size: 1.3rem;
      line-height: 1.5rem;
    }

    .featured {
      color: $black;

      i {
        font-style: normal !important;
      }
    }

    .btn {
      font-size: 1.8rem;
      line-height: 2rem;
      font-weight: $font-weight-bold;
      padding: 0.5rem 1rem;

      @media (max-width: prev-viewport-max-size("md")) {
        font-size: 1.8rem;
        line-height: 2rem;
      }

      @media (max-width: prev-viewport-max-size("sm")) {
        font-size: 1.3rem;
        padding: 0.3rem 0.5rem;
      }
    }

    div[class^="col-"],
    div[class*=" col-"] {
      @media (max-width: prev-viewport-max-size("md")) {
        margin-bottom: 0.3rem;
        margin-top: 0.5rem;
      }
    }
  }

  .stripe-search {
    background-color: $redDark;
  }

  .stripe-color {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;

    * {
      height: 100%;
    }

    .stripe-left {
      background-color: $red;
    }

    .stripe-right {
      background-color: $redDark;
      display: none;
    }
  }
}

@media (max-width: prev-viewport-max-size("md")) {
  .stripe {
    .container {
      max-width: 100%;
    }
  }
}
</style>
